import { render, staticRenderFns } from "./LatestPosts.vue?vue&type=template&id=cacd2cf4"
import script from "./LatestPosts.vue?vue&type=script&lang=js"
export * from "./LatestPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports